export const clamp = (value: number) => Math.min(100, Math.max(0, value))
